module.exports = __webpack_public_path__ + "img/42.335c19fe.png";